const Ui = () => {
  // JSX
  return <div>Ui</div>;
};

export default Ui;
